<template>
    <section class="pb_cover_v3 overflow-hidden cover-bg-indigo cover-bg-opacity text-left pb_gradient_v1 pb_slant-light" id="section-home">
      <div :style="`background-image: url(${require('../assets/images/img1.jpg')});`" class="bg"></div>
      <div class="container">
            <div class="row align-items-center justify-content-center">
                <div class="col-md-6">
                    <h2 class="heading mb-3">Тайм-кафе «Зая»</h2>
                    <div class="sub-heading">
                        <p class="mb-1">Тайм-кафе «Зая» создает максимально комфортных условий для отдыха, работы и проведения деловых встреч или веселого времяпровождения с друзьями.</p>
                        <p class="mb-5 mt-4"><a class="btn btn-ok btn-lg pb_btn-pill smoothscroll" href="#section-pricing"><span class="pb_font-14 text-uppercase pb_letter-spacing-1">Прайслист</span></a></p>
                    </div>
                </div>
                <div class="col-md-1">
                </div>
            </div>
        </div>
    </section>
</template>

<script>
    export default {
        name: "Home"
    }
</script>

<style lang="scss">
.bg {
  height: 100%;
  width: 100%;
  position: absolute;
  background-position: center;
  background-size: cover;
  filter: brightness(0.5);
}

</style>
